<!-- 总部库存明细 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr12" src="../../assets/information.png">
            <div>
                <div>库存总数每24小时须存更新一次，可以通过更新缓存的方式手动更新。</div>
                <div>1.已经关联了经销商或门店或者已经零售出库的码，不会计入总部库存。</div>
                <div>2.未入库的码或空码不会计入总部库存。</div>
            </div>
        </div>
        <div class="header_div">
            <Input class="w200 mr24" type="text" v-model="storePrams.name" placeholder="输入产品名称关键词搜索产品"></Input>
            <Button class="theme-bc theme-default-color" icon="ios-search" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="show_product_imgs">
                        <div class="flex-c">
                            <img class="width_60 mt12 mb12" v-if="row.show_product_imgs.length > 0" :src="row.show_product_imgs[0]">
 	                        <img class="width_60 mt12 mb12" v-else src="../../assets/example.png">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goInfo(row)">详情</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 总部库存详情 -->
        <Drawer v-model="infoModal" title="总部库存详情" width="80">
            <div class="drawer_div">
                <Input class="w300 mr24" type="text" v-model="pagesDrawer.qrcode_number" placeholder="输入溯源码编码或扫描溯源码"></Input>
                <Select class="w200 mr24" v-model="pagesDrawer.batch_id" clearable filterable placeholder="选择所属批次">
                    <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                </Select>
                <Select class="w200 mr24" v-model="pagesDrawer.warehouse_id" clearable filterable placeholder="选择所属仓库">
                    <Option v-for="item in warehouseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Button class="theme-bc theme-default-color" icon="ios-search" @click="goSearchDrawer">确定搜索</Button>
            </div>
            <Table :columns="columnsDrawer" :data="dataDrawer" border>
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div class="flex-c">
                        <img class="width_60 mt12 mb12" v-if="row.qrcode.product.show_product_imgs" :src="row.qrcode.product.show_product_imgs[0]">
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product">
                    <div>{{row.qrcode.product.product_name}} {{row.qrcode.product.specs}}</div>
                </template>
                <template slot-scope="{ row }" slot="produce_time">
                    <div>
                        <div v-if="row.qrcode.produce_time">生产时间：{{row.qrcode.produce_time}}</div>
                        <div v-if="row.qrcode.expire_time">到期时间：{{row.qrcode.expire_time}}</div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="batch">
                    <div>{{row.qrcode.batch.batch_name}}</div>
                </template>
                <template slot-scope="{ row }" slot="box">
                    <div>
                        <template v-if="row.box">
                            <div v-if="row.box.big_box_number">大箱：{{row.box.big_box_number}}</div>
                            <div v-if="row.box.small_box_number">小箱：{{row.box.small_box_number}}</div>
                        </template>
                        <template v-else><div><Icon type="ios-alert-outline"/>未装箱</div></template>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="warehouse">
                    <div>{{row.warehouse.name}}</div>
                </template>
            </Table>
            <div class="page">
                <Page :current="pagesDrawer.page" :page-size="pagesDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="changeDrawer"/>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { 
    warehouse_headquarters_list, 
    warehouse_headquarters_product,
    get_options, 
    warehouse_select,
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
                warehouse_id: "",
            },
            total: 0,
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称", key: "name", align: "center" },
                { title: "当前总部库存", key: "qrcode_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataTable: [],
            infoModal: false,
            columnsDrawer: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称及规格", slot: "product", align: "center" },
                { title: "质保期情况", slot: "produce_time", align: "center" },
                { title: "产品溯源码编码", key: "qrcode_number", align: "center" },
                { title: "所属批次", slot: "batch", align: "center" },
                { title: "大(小)箱码", slot: "box", align: "center" },
                { title: "所属仓库", slot: "warehouse", align: "center" },
            ],
            dataDrawer: [],
            pagesDrawer: {
                product_id: "",
                page: 1,
                limit: 10,
                batch_id: "",
                qrcode_number: "",
                warehouse_id: "",
            },
            totalDrawer: 0,
            batchList: [],
            warehouseList: [],
        };
    },
    mounted() {
        this.getOptions();
        this.getWarehouseSelect();
        if(this.$route.query.id){
            this.storePrams.warehouse_id = this.$route.query.id;
            this.getList();
        }else{
            this.getList();
        }
    },
    methods: {
        getList() {
            warehouse_headquarters_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 总部库存单个商品的溯源码列表
        getInfoList() {
            warehouse_headquarters_product(this.pagesDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changeDrawer(index) {
            this.pagesDrawer.page = index;
            this.getInfoList();
        },
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        goSearchDrawer(){
            this.pagesDrawer.page = 1;
            this.getInfoList();
        },
        getOptions(){
            get_options().then((res) => {
                this.batchList = res.data.batch;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getWarehouseSelect(){
            warehouse_select().then((res) => {
                this.warehouseList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goInfo(row){
            this.pagesDrawer.product_id = row.id;
            this.getInfoList()
            setTimeout(() => {
                this.infoModal = true;
            }, 300);
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.header_div {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_60 {
    width: 60px;
    height: 60px;
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.drawer_div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 24px 0;
}
</style>